import { Drawer, useMediaQuery } from "@mui/material";
import classnames from "classnames";
import { useCaptureEventsV2 } from "@gx1/gx-npm-lib";
import { useContext, useEffect, useRef, useState } from "react";
import { ClientEvent } from "../../app.constants";
import { MainNavAppV2Context } from "../../app-v2.context";
import NotificationsHeaderComponent from "./notifications-header/notifications-header.component";
import NotificationsContainerComponent from "./notifications-container/notifications-container.component";
import { DRAWER_TRANSITION_DURATION } from "./notifications.constants";
import styles from "./notifications-v2.styles.module.scss";

const NotificationsV2Component = () => {
  const { isNotificationsPanelOpen, setIsNotificationsPanelOpen } = useContext(MainNavAppV2Context);
  const [isDrawerEntered, setIsDrawerEntered] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const contentWrapperRef = useRef<HTMLDivElement>(null);
  const isDesktopView = useMediaQuery("(min-width: 768px)");
  const captureEvents = useCaptureEventsV2();

  useEffect(() => {
    if (!isNotificationsPanelOpen) {
      return;
    }
    captureEvents([{ eventType: ClientEvent.NOTIFICATIONS_FEED_VIEWED }]);
  }, [isNotificationsPanelOpen, captureEvents]);

  useEffect(() => {
    if (!isDrawerEntered) {
      return;
    }
    const currentContentWrapperEl = contentWrapperRef.current;
    const updateScrollState = () => {
      if (currentContentWrapperEl) {
        setIsScrolled(currentContentWrapperEl.scrollTop > 0);
      }
    };
    if (currentContentWrapperEl) {
      currentContentWrapperEl.addEventListener("scroll", updateScrollState);
      return () => {
        currentContentWrapperEl.removeEventListener("scroll", updateScrollState);
      };
    }
  }, [isDrawerEntered]);

  const handleClose = () => {
    setIsNotificationsPanelOpen(false);
    setIsDrawerEntered(false);
    setIsScrolled(false);
  };

  return (
    <Drawer
      anchor="right"
      classes={{ root: styles.muiDrawerRoot, paper: styles.muiDrawerPaper }}
      slotProps={{ backdrop: { classes: { root: styles.muiDrawerMuiBackdropRoot } } }}
      onClose={handleClose}
      onTransitionEnter={() => setIsDrawerEntered(true)}
      open={isNotificationsPanelOpen}
      transitionDuration={isDesktopView ? DRAWER_TRANSITION_DURATION : 0}
    >
      <div className={classnames(styles.headerWrapper, isScrolled && styles.scrolled)}>
        <NotificationsHeaderComponent />
      </div>
      <div className={styles.contentWrapper} ref={contentWrapperRef}>
        <NotificationsContainerComponent ref={contentWrapperRef} />
      </div>
    </Drawer>
  );
};

export default NotificationsV2Component;
